import React, { useEffect, useRef } from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";

export default function Convention_1_V6({
  version = "v6",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  // TODO 리팩토링
  const handleNext = () => {
    navigate(`/${versionToPathPrefix(version)}-onboarding/convention/2?q=1`, {
      replace: true,
    });
  };

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {});

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "60vh" }}>
      <Box
        sx={{
          flex: 1, // 상단 헤더와 하단 버튼 사이 남은 공간 전부 사용
          display: "flex",
          flexDirection: "column",
          justifyContent: "center", // 세로 가운데 정렬
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {"디스턴싱은 스스로 변화를 만듭니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {"무언가에 의지하지 않습니다."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {
              "행동과학을 기반으로 하는 인지치료는 약물 의존 없이도 대부분의 정신질환을 치료할 수 있도록 구성되어 있습니다."
            }
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            지금부터 나에게는 어떤 행동과학적 접근 방식이 적합한지
            알아보겠습니다.
          </CustomTypography>
        </Stack>
      </Box>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"다음"}
      />
    </Box>
  );
}
